import { NextComponentType } from 'next/types'
import { ProfilePageProps } from 'interfaces'
import { Loader } from '@rario/shared-components'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const UserProfileFanBadge: NextComponentType<{}, {}, ProfilePageProps> = () => {
  const router = useRouter()

  useEffect(() => {
    router.push('/profile')
  }, [router])

  return <Loader />
}

export default UserProfileFanBadge
